import { render, staticRenderFns } from "./Numpad.vue?vue&type=template&id=38a2fbe6&"
import script from "./Numpad.vue?vue&type=script&lang=js&"
export * from "./Numpad.vue?vue&type=script&lang=js&"
import style0 from "./Numpad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a2fbe6')) {
      api.createRecord('38a2fbe6', component.options)
    } else {
      api.reload('38a2fbe6', component.options)
    }
    module.hot.accept("./Numpad.vue?vue&type=template&id=38a2fbe6&", function () {
      api.rerender('38a2fbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Calculator/Numpad.vue"
export default component.exports